import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import FooterComponent from "/components/core/footer-new/footer-component";

import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";

import BaseTemplate from "/components/templates/base-template";

import OnePagerWithImageContentComponent from "./one-pager-with-image-content/one-pager-with-image-content-component";

export default class OnePagerWithImageTemplate extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let { exitPopup, stickyMode, pageConfig } = this.props;
    const { socialButtons, footer, topbar, topBanner, exitPopupConfig } = pageConfig;

    const topbarConfig = topbar || {};
    const footerConfig = footer || {};
    const showHeader = topbarConfig.showMenu || false;
    return (
      <BaseTemplate {...this.props} {...pageConfig}>
        <Topbar
          loginTheme={topbarConfig.loginTheme}
          menuTheme={topbarConfig.menuTheme}
          showMenu={showHeader}
          shortHeader={topbarConfig.shortHeader}
          headerBackgroundColor={"white"}
          stickyMode={stickyMode}
          allowSocialButtons={socialButtons && socialButtons.show}
          socialButtonsColor={socialButtons && socialButtons.color}
          mobileLogoTheme={"dark-theme"}
          topBanner={topBanner}
          maxWidth="100%"
        />
        <main>
          <OnePagerWithImageContentComponent {...pageConfig} />
        </main>

        {!footerConfig.preventFooter && (
          <div className="footer-wrapper">
            <FooterComponent />
          </div>
        )}
        <CoreAddonsComponent exitPopup={exitPopup} exitPopupConfig={exitPopupConfig} />
      </BaseTemplate>
    );
  }
}

OnePagerWithImageTemplate.defaultProps = {
  title: "monday.com",
  description: "",
  exitPopup: true
};
